import DefaultLayout from "../components/layout/DefaultLayout";
import Greeting from "../components/lessee/Greeting";
import ListPendingInvoices from "../components/lessee/ListPendingInvoices";
function LesseeHome() {
  const body = () => {
    return (
      <div>
        <section className="slice sct-color-1" id="scrollToSection">
          <div className="container">
            <div className="section-title section-title--style-1 text-center mb-5">
              <Greeting />
              <span className="section-title-delimiter clearfix d-none"></span>
            </div>
            <span className="clearfix"></span>

            <div className="fluid-paragraph fluid-paragraph-sm c-gray-light strong-300 text-center">
              <ListPendingInvoices></ListPendingInvoices>
            </div>

            <span className="space-xs-md"></span>
          </div>
        </section>
      </div>
    );
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default LesseeHome;
